import { forwardRef } from 'react';
import createElement from 'react-native-web/dist/exports/createElement';
export const HR = forwardRef((props, ref) => {
    return createElement('hr', { ...props, ref });
});
//# sourceMappingURL=Rules.web.js.map